import loadable from '@/utils/loadable';
import {
  BoardRouteSkeleton,
  FormRouteSkeleton,
  LobbyRouteSkeleton,
  TableRouteSkeleton,
} from '@/components/common/RouteSkeletons';

// Route-level fallbacks. `loadable`'s default is the shared spinner; a route
// that knows its own shape passes one of these instead, so the lazy chunk's
// wait looks like the page that is coming rather than like every other page.
const lobby = { fallback: <LobbyRouteSkeleton /> };
const board = { fallback: <BoardRouteSkeleton /> };
const table = { fallback: <TableRouteSkeleton /> };
const form = { fallback: <FormRouteSkeleton /> };

export const LoginPage = loadable(() => import('@/pages/auth/LoginPage'));
export const RegisterPage = loadable(() => import('@/pages/auth/RegisterPage'));
export const HomePage = loadable(() => import('@/pages/Home'), lobby);
export const SportsPage = loadable(() => import('@/pages/Sports'), board);
export const LivePage = loadable(() => import('@/pages/Live'), board);
export const MarketsPage = loadable(() => import('@/pages/Markets'), board);
export const CasinoPage = loadable(() => import('@/pages/Casino'), lobby);
export const CasinoPlaygroundPage = loadable(() => import('@/pages/CasinoPlayground'));
export const GoalGamePage = loadable(() => import('@/pages/GoalGame'));
export const QTECHLobbyPage = loadable(() => import('@/pages/QTECHLobby'), lobby);
export const QTECHCasinoPage = loadable(() => import('@/pages/QTECHCasino'), lobby);
export const FantasyListPage = loadable(() => import('@/pages/FantasyList'), board);
export const LiveCasinoPage = loadable(() => import('@/pages/LiveCasino'), lobby);
export const SlotsPage = loadable(() => import('@/pages/Slots'), lobby);
// Aggregator-backed casino lobby — mounted on /casino/* for brands that use it.
export const NexxCasinoPage = loadable(() => import('@/pages/Casino/NexxCasino'), lobby);
export const BlankPage = loadable(() => import('@/pages/BlankPage'));
export const AccountStatementPage = loadable(() => import('@/pages/AccountStatment'), table);
export const BetHistoryPage = loadable(() => import('@/pages/BetHistory'), table);
export const AffiliatePage = loadable(() => import('@/pages/Affiliate'), table);
export const ActivityLogsPage = loadable(() => import('@/pages/ActivityLog'), table);
export const CasinoResultsPage = loadable(() => import('@/pages/CasinoResults'), table);
export const AuthVerificationPage = loadable(() => import('@/pages/AuthVerification'), form);
export const ChangePasswordPage = loadable(() => import('@/pages/ChangePassword'), form);
export const ProfilePage = loadable(() => import('@/pages/Profile'), form);
export const TermsConditionsPage = loadable(() => import('@/pages/TermsAndConditions'));
export const CasinoBetHistory = loadable(() => import('@/pages/CasinoBetHistory'), table);
export const DepositWithdrawPage = loadable(() => import('@/pages/DepositWithdraw'), table);
export const DepositPage = loadable(() => import('@/pages/DepositWithdraw/DepositPage'), form);
export const FixedDepositPage = loadable(() => import('@/pages/FixedDeposit'), form);
export const ContactPage = loadable(() => import('@/pages/ContactPage'), form);
export const WalletHistoryPage = loadable(() => import('@/pages/WalletHistory'), table);
export const BonusesPage = loadable(() => import('@/pages/Bonuses'), lobby);
export const TutorialsPage = loadable(() => import('@/pages/Tutorials'));
